import { connect } from 'react-redux';

import { OBJECT_TYPE_JOBS } from '@iconik-io/iconik-api/src/types/object_types';

import { deleteJobsByIds } from '../../../ducks/pages/admin_jobs_history/thunks';
import DeleteObjectsModal from './delete_objects';

const DeleteJobsModal = connect(
  () => ({
    objectType: OBJECT_TYPE_JOBS,
  }),
  {
    deleteEntityByIds: deleteJobsByIds,
  },
)(DeleteObjectsModal);

export default DeleteJobsModal;
